
import request from '@/utils/request'
export function listMessage () {
    return request({
        url: '/v1/message/',
        method: 'get',
    })
}
export function addMessage (data) {
    return request({
        url: '/v1/message/',
        method: 'post',
        data
    })
}
export function getImHistory (params) {
    return request({
        url: '/v1/im/',
        method: 'get',
        params: params
    })
}
export function getRoomList () {
    return request({
        url: '/v1/im/getRoomList',
        method: 'get'
    })
}
export function addRoom (userId) {
    return request({
        url: '/v1/im/addRoom',
        method: 'post',
        params: {
            userId: userId
        }
    })
}
export function send (data) {
    return request({
        url: '/v1/im/chat',
        method: 'post',
        data
    })
}
export function withdraw (data) {
    return request({
        url: '/v1/im/withdraw',
        method: 'post',
        data
    })
}
export function getUserImHistoryList (params) {
    return request({
        url: '/v1/im/selectUserImHistory',
        method: 'get',
        params: params
    })
}
export function read (userId) {
    return request({
        url: '/v1/im/read',
        method: 'get',
        params: {
            userId: userId
        }
    })
}
export function deleteRoom (roomId) {
    return request({
        url: '/v1/im/deleteRoom',
        method: 'delete',
        params: {
            roomId: roomId
        }
    })
}
export function getMessageNotice (params) {
    return request({
        url: '/v1/im/getMessageNotice',
        method: 'get',
        params: params
    })
}
export function getNewSystemNotice () {
    return request({
        url: '/v1/im/getNewSystemNotice',
        method: 'get',
    })
}
export function deleteMessage (params) {
    return request({
        url: '/v1/im/deleteMessage',
        method: 'delete',
        params: params
    })
}

/**
 * 根据通知ID删除消息
 * @param {String|Number} id - 消息ID
 */
export function deleteByNoticeId (id) {
    return request({
        url: '/v1/im/deleteByNoticeId',
        method: 'get',
        params: { id }
    })
}

// ========== 私聊消息相关接口 ==========
/**
 * 个人中心发送私信
 */

// 发送私聊消息
export function sendChatMessage (data) {
    return request({
        url: '/v1/chat/send',
        method: 'post',
        data
    })
}
/**
 * 获取会话列表
 * @param {Object} params - { pageNo, pageSize }
 *
 * 注意：这里原来没有声明形参，调用方传的分页参数被直接丢掉，
 * 于是会话列表滚动加载时每次都在请求第 1 页并把同一批会话反复追加进列表
 * （v-for 还会因为 key 重复报警）。
 */
export function getChatSessions (params) {
    return request({
        url: '/v1/chat/sessions',
        method: 'get',
        params
    })
}

/**
 * 获取聊天历史记录
 * @param {Object} params - { targetUserId, pageNo, pageSize }
 */
export function getChatHistory (params) {
    return request({
        url: '/v1/chat/history',
        method: 'get',
        params
    })
}

/**
 * 删除会话（软删除）
 * @param {String} targetUserId - 对方用户ID
 */
export function deleteChatSession (targetUserId) {
    return request({
        url: `/v1/chat/session/${targetUserId}`,
        method: 'delete'
    })
}

/**
 * 置顶会话（只对自己生效）
 * @param {String} targetUserId - 对方用户ID
 */
export function pinChatSession (targetUserId) {
    return request({
        url: `/v1/chat/session/${targetUserId}/pin`,
        method: 'put'
    })
}

/**
 * 取消置顶会话
 * @param {String} targetUserId - 对方用户ID
 */
export function unpinChatSession (targetUserId) {
    return request({
        url: `/v1/chat/session/${targetUserId}/pin`,
        method: 'delete'
    })
}

/**
 * 会话免打扰（只对自己生效）
 * @param {String} targetUserId - 对方用户ID
 */
export function muteChatSession (targetUserId) {
    return request({
        url: `/v1/chat/session/${targetUserId}/mute`,
        method: 'put'
    })
}

/**
 * 取消会话免打扰
 * @param {String} targetUserId - 对方用户ID
 */
export function unmuteChatSession (targetUserId) {
    return request({
        url: `/v1/chat/session/${targetUserId}/mute`,
        method: 'delete'
    })
}

/**
 * 删除某条私聊消息（仅自己不可见，对方聊天记录不受影响）
 * @param {String} messageId - 消息业务ID
 */
export function deleteChatMessage (messageId) {
    return request({
        url: `/v1/chat/message/${messageId}`,
        method: 'delete'
    })
}

/**
 * 获取未读消息总数
 */
export function getUnreadCount () {
    return request({
        url: '/v1/chat/unread/count',
        method: 'get'
    })
}

/**
 * 批量查询在线状态
 *
 * 服务端会主动推送 online_status，这个接口只用在两个「推送覆盖不到」的时刻：
 *   1. 刚进私信页 / 刚打开某个会话，需要一份初始值；
 *   2. WebSocket 重连之后，断连期间的推送已经丢了，需要整体校准。
 *
 * 返回的 data 是 { userId: boolean } 映射，没查到的 id 也会显式回 false，
 * 调用方可以直接整体覆盖本地状态，不用区分「离线」和「查不到」。
 *
 * @param {Array<String>|String} targetUserIds - 用户ID数组或逗号分隔字符串，单次上限 100
 */
export function getChatOnlineStatus (targetUserIds) {
    const ids = Array.isArray(targetUserIds) ? targetUserIds.join(',') : targetUserIds
    return request({
        url: '/v1/chat/online/status',
        method: 'get',
        params: { targetUserIds: ids }
    })
}
